<template>
  <div class="trialDetail">
    <viewHeader></viewHeader>
    <div class="mainContent">
      <el-card
        class="box-card"
        shadow="never"
        v-loading="loading"
        :element-loading-text="loadingText"
      >
      <el-row :gutter="30" class="fullTitle" slot="header">
        <el-col class="title clearfix">
          <img src="../assets/img/icon7.png" alt="" class="L" />
          <span class="L">{{ detailInfo.title_brief }}</span>
        </el-col>
      </el-row>
      <el-row class="clearfix actionRow">
        <div class="labels">
          <div class="labelItem" v-show="detailInfo.regdate">
            <img class="icon" src="../assets/img/icon_label_calendar.png"/>
            <span class="text">{{ parseRegdate(detailInfo.regdate) }}</span>
          </div>
          <div class="labelItem" v-show="detailInfo.status">
            <img class="icon" src="../assets/img/icon_label_trial.png"/>
            <span class="text">{{ detailInfo.status }}</span>
          </div>
          <div class="labelItem" v-show="detailInfo.sample_size">
            <img class="icon" src="../assets/img/icon_label_person.png"/>
            <span class="text">{{ parseSampleSize(detailInfo.sample_size_type) }}: {{ detailInfo.sample_size }}</span>
          </div>
          <div class="labelItem" v-show="detailInfo.rct_phase">
            <img class="icon" src="../assets/img/icon_label_trial.png"/>
            <span class="text">{{ detailInfo.rct_phase && detailInfo.rct_phase.join(" ") }}</span>
          </div>
          <div class="labelItem" v-show="detailInfo.study_type">
            <img class="icon" src="../assets/img/icon_label_trial.png"/>
            <span class="text">{{detailInfo.study_type }}</span>
          </div>
        </div>
        <p class="R action clearfix">
          <a href="javascript:;" class="translate L" @click="handleTranslate">
            <img src="../assets/img/icon1-1.png" alt="" />
            <span class="text">翻译</span>
          </a>
          <a
            @click="collection"
            href="javascript:;"
            class="L"
            :class="detailInfo.is_collected ? 'collectionTrue' : 'collection'">
            <img src="../assets/img/icon3-1.png" alt="" v-show="!detailInfo.is_collected"/>
            <img src="../assets/img/icon3_01.png" alt="" v-show="detailInfo.is_collected"/>
            <span class="text">{{ detailInfo.is_collected ? "已收藏" : "收藏" }}</span>
            </a>
          <a :href="detailInfo.url" target="__blank" class="L">
            <img src="../assets/img/icon_8.png" alt="" />
            <span class="text">原网站</span>
          </a>
          <a href="javascript:;" class="L" @click="handleRelated" v-if="detailInfo.reference">
            <img src="../assets/img/icon_RetaledLiterature.png" alt="" />
            <span class="text">相关文献</span>
          </a>
          <a href="javascript:;" class="L" @click="handleSimilarTrial">
            <img class="rotate" src="../assets/img/icon_similartrial.png" alt="" />
            <span class="text">相似研究</span>
          </a>
        </p>
      </el-row>
      <div class="sectionList">
        <div class="section">
          <div class="content">
            <div class="main">
              <div class="item" v-show="detailInfo.registration">
                <div class="label">{{ sectionName("ClinicalTrials.gov ID") }}</div>
                <div class="value">{{ detailInfo.registration }}</div>
              </div>
              <div class="item" v-show="detailInfo.sponsor">
                <div class="label">{{ sectionName("Sponsor") }}</div>
                <div class="value">{{ detailInfo.sponsor }}</div>
              </div>
              <div class="item" v-show="detailInfo.update">
                <div class="label">{{ sectionName("Last Update Posted") }}</div>
                <div class="value">{{ detailInfo.update }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="sectionVisible().showStudyOverview">
          <div class="title">{{ sectionName("Study Overview") }}</div>
          <div class="content">
            <div class="main">
              <div class="item" v-show="detailInfo.description">
                <div class="label">{{ sectionName("Brief Summary") }}</div>
                <div class="value">{{ detailInfo.description }}</div>
              </div>
              <div class="item" v-show="detailInfo.title">
                <div class="label">{{ sectionName("Official Title") }}</div>
                <div class="value">{{ detailInfo.title }}</div>
              </div>
              <div class="item" v-show="detailInfo.population">
                <div class="label">{{ sectionName("Conditions") }}</div>
                <div class="value">
                  <span class="tag" v-for="(item,index) in detailInfo.population" :key="index">{{ item }}</span>
                </div>
              </div>
              <div class="item" v-show="detailInfo.intervention">
                <div class="label">{{ sectionName("Intervention / Treatment") }}</div>
                <div class="value">
                  <ul class="bullet">
                    <li class="bulletItem" v-for="(item,index) in detailInfo.intervention" :key="index">{{ item[0] }}: {{ item[1] }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="infoList">
              <div class="item" v-show="detailInfo.start_date">
                <div class="label">{{ sectionName("Study Start") }}</div>
                <div class="value">{{ detailInfo.start_date }}</div>
              </div>
              <div class="item" v-show="detailInfo.completion_date">
                <div class="label">{{ sectionName("Study Completion") }} <span v-show="detailInfo.completion_date_type">({{ detailInfo.completion_date_type }})</span></div>
                <div class="value">{{ detailInfo.completion_date }}</div>
              </div>
              <div class="item" v-show="detailInfo.study_type">
                <div class="label">{{ sectionName("Study Type") }}</div>
                <div class="value">{{ detailInfo.study_type }}</div>
              </div>
              <div class="item" v-show="detailInfo.rct_phase">
                <div class="label">{{ sectionName("Phase") }}</div>
                <div class="value" v-for="(item,index) in detailInfo.rct_phase" :key="index">{{ item }}  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="sectionVisible().showParticipationCriteria">
          <div class="title">{{ sectionName("Participation Criteria") }}</div>
          <div class="subSection" v-show="sectionVisible().showEligibilityCriteria">
            <div class="subsectionTitle">{{ sectionName("Eligibility Criteria") }}</div>
            <div class="content">
              <div class="main">
                <div class="item" v-show="detailInfo.inclusion_criteria">
                  <div class="label">{{ sectionName("Description") }}</div>
                  <div class="value">{{ detailInfo.inclusion_criteria }}</div>
                </div>
              </div>
              <div class="infoList">
                <div class="item" v-show="detailInfo.age">
                  <div class="label">{{ sectionName("Ages Eligible for Study") }}</div>
                  <div class="value">{{ detailInfo.age }}</div>
                </div>
                <div class="item" v-show="detailInfo.gender">
                  <div class="label">{{ sectionName("Sexes Eligible for Study") }}</div>
                  <div class="value">{{ detailInfo.gender }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="sectionVisible().showStudyPlan">
          <div class="title">{{ sectionName("Study Plan") }}</div>
          <div class="subSection" v-show="sectionVisible().showDesignDetails">
            <div class="subsectionTitle">{{ sectionName("Design Details") }}</div>
            <div class="content">
              <div class="main">
                <div class="item">
                  <div class="value">
                    <div class="valueList">
                      <div class="valueItem" v-show="detailInfo.primary_purpose">
                        <span class="k">{{ sectionName("Primary Purpose") }}: </span>
                        <span class="v">{{ detailInfo.primary_purpose }}</span>
                      </div>
                      <div class="valueItem" v-show="detailInfo.allocation">
                        <span class="k">{{ sectionName("Allocation") }}: </span>
                        <span class="v">{{ detailInfo.allocation }}</span>
                      </div>
                      <div class="valueItem" v-show="detailInfo.design_model">
                        <span class="k">{{ sectionName(`${studyType} Model`) }}: </span>
                        <span class="v" v-for="(item,index) in detailInfo.design_model" :key="index">{{ item }}</span>
                      </div>
                      <div class="valueItem" v-show="detailInfo.time_perspective">
                        <span class="k">{{ sectionName(`Time Perspective`) }}: </span>
                        <span class="v" v-for="(item,index) in detailInfo.time_perspective" :key="index">{{ item }}</span>
                      </div>
                      <div class="valueItem" v-show="detailInfo.masking">
                        <span class="k">{{ sectionName("Masking") }}: </span>
                        <span class="v">{{ detailInfo.masking }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="subSection" v-show="sectionVisible().showOutcomeMeasures">
            <div class="subsectionTitle">{{ sectionName("Outcome Measures") }}</div>
            <div class="content">
            <div class="main">
              <div class="item" v-show="detailInfo.outcome_primary">
                <div class="label">{{ sectionName("Primary Outcome Measures") }}</div>
                <div class="value">
                  <ul class="bullet">
                    <li class="bulletItem" v-for="(item,index) in detailInfo.outcome_primary" :key="index">{{ item }}</li>
                  </ul>
                </div>
              </div>
              <div class="item" v-show="detailInfo.outcome_secondary">
                <div class="label">{{ sectionName("Secondary Outcome Measures") }}</div>
                <div class="value">
                  <ul class="bullet">
                    <li class="bulletItem" v-for="(item,index) in detailInfo.outcome_secondary" :key="index">{{ item }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </el-card>
    </div>
  </div>
</template>
<script>
import { md5 } from "md5js";
import { webTrackerEvent } from "../utils/tracker";
import viewHeader from "./viewHeader";
import { trialDetail,trialCollect, trialTranslate } from '../service/getData'
import { clinicalTrialsSectionName } from '../utils/articleTags'
export default {
  name: 'trialDetail',
  components: {
    viewHeader
  },
  data() {
    return {
      loading: false,
      loadingText : '拼命加载中',
      registration: undefined,// 研究id
      searchType: "",
      detailInfoFullData: {},
      language: "en",// cn/en
      studyType: '',
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      
    }
  },
  computed: {
    detailInfo() {
      return this.detailInfoFullData[this.language] || {};
    }
  },
  methods: {
    /**
     * 翻译章节标题
     */
    sectionName(enName) {
      if(this.language == 'en') return enName;
      const cnName = clinicalTrialsSectionName[enName];
      return cnName || enName;
    },
    /**
     * 翻译
     */
    async handleTranslate() {
      if(this.language == 'cn') {
        this.language = 'en';
        return;
      }
      // 已经翻译过，直接取
      if(this.detailInfoFullData.cn && typeof this.detailInfoFullData.cn == 'object') {
        this.language = 'cn';
        return;
      }

      // 首次翻译
      this.loading = true;
      const clientId = "zeta";
      const secret = "4ede4aafbzd51cbz3e32bzb781bzee9813d17154";
      const ts = new Date().getTime();
      const tokenStr = `${clientId}.bz${ts}.bz${this.detailInfo.registration}.bz${secret}`;
      const token = md5(tokenStr, 32);
      const params = {
        client_id: clientId,
        ts: Number(ts),
        registration: String(this.detailInfo.registration),
        token: token,
      };
      const res = await trialTranslate(params);
      this.loading = false;
      const { status, data } = res.data;
      if(status == 0) {
        const { en } = this.detailInfoFullData;
        const cnData = {
          ...en,
          ...data
        }
        this.detailInfoFullData.cn = cnData;
        this.language = 'cn';
        // log
        let Logger = webTrackerEvent();
        Logger.push("action", "translate_clinical_trial");
        Logger.push("info", "en2cn");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", this.detailInfo.registration);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();

      } else {
        this.$message.error('请重试！');
      }
    },
    /**
     * 获取详情
     */
    async handleGetDetail() {
      this.loading = true;
      const res = await trialDetail(this.registration);
      this.loading = false;
      if (res && res.data.status === 0) {
        this.detailInfoFullData = {
          en: res.data.data,
          cn: undefined
        }
        this.studyType = res.data.data.study_type;
      } else {
        this.$message.error("获取失败，请重试");
      }
    },
    /**
     * 收藏/取消收藏
     */
    collection() {
      if (!this.detailInfo.is_collected) {
        let Logger = webTrackerEvent();
        Logger.push("action", "collection_trial");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", this.detailInfo.registration);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        trialCollect("POST", { registration: this.detailInfo.registration }).then((res) => {
          if (res.data.status === 0) {
            this.detailInfo.is_collected = true;
          } else {
            this.$message({
              message: "收藏失败，请重试",
              type: "error",
            });
          }
        });
      } else {
        let Logger = webTrackerEvent();
        Logger.push("action", "cancel_collection_trial");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", this.detailInfo.registration);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        trialCollect("DELETE", { registration: this.detailInfo.registration }).then((res) => {
          if (res.data.status === 0) {
            this.detailInfo.is_collected = false;
          } else {
            this.$message({
              message: "取消失败，请重试",
              type: "error",
            });
          }
        });
      }
    },
    /**
     * 相关文献
     */
    handleRelated() {
      const { registration, reference } = this.detailInfo;
      const { href } = this.$router.resolve({
        name: 'related',
        query: {
          registration,
          t: reference.join('.')
        }
      });
      window.open(href);
    },
    /**
     * 相似研究
     */
    handleSimilarTrial() {
      const { registration } = this.detailInfo;
      const { href } = this.$router.resolve({
        name: 'similarTrial',
        query: {
          registration
        }
      });
      window.open(href);
    },
    /**
     * 格式化注册日期标签
     */
    parseRegdate(value) {
      if(this.language == 'en') {
        return `Registered on ${value}`
      } else {
        return `${value} 注册`;
      }
    },
    /**
     * 格式化样本量标签
     */
    parseSampleSize(value) {
      if(value) return value;
      
      if(this.language == 'en') {
        return 'Sample size'
      } else {
        return '样本量' 
      }
    },
    /**
     * 每个模块的显示状态
     */
    sectionVisible() {
      const {description, title, population, intervention, start_date, completion_date, study_type, rct_phase, inclusion_criteria, age, gender, primary_purpose, allocation,design_model, time_perspective, masking,outcome_primary,outcome_secondary   } = this.detailInfo;
      const showStudyOverview = description || title || population || intervention || start_date || completion_date || study_type || rct_phase;
      const showEligibilityCriteria = inclusion_criteria || age || gender;
      const showParticipationCriteria = showEligibilityCriteria;
      const showDesignDetails = primary_purpose || allocation || design_model || time_perspective || masking;
      const showOutcomeMeasures = outcome_primary || outcome_secondary;
      const showStudyPlan = showDesignDetails || showOutcomeMeasures;
      return {
        showStudyOverview,
        showEligibilityCriteria,
        showParticipationCriteria,
        showDesignDetails,
        showOutcomeMeasures,
        showStudyPlan
      }
    }
  },
  destroyed () {
    let Logger = webTrackerEvent();
    Logger.push("action", "pageUnload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", this.currentPageUrl);
    Logger.logger();
  },
  created() {
    const { registration, searchType } = this.$route.query;
    this.registration = registration;
    this.searchType = searchType;
    this.handleGetDetail();

    // log
    let Logger = webTrackerEvent();
    Logger.push("action", "pageload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", window.location.href);
    Logger.logger();
  },
}
</script>
<style lang="less" scoped>
.trialDetail {
  min-height: 100vh;
  background: #f9f9f9;
  padding-bottom: 50px;
  .mainContent {
    width: 1080px;
    margin: 0 auto;
    .fullTitle {
      font-size: 16px;
      color: #4083d4;
      .title {
        display: flex;
        span {
          flex: 1;
          margin-left: 18px;
          font-size: 16px;
          font-weight: bold;
          // line-height: 34px;
          // width: 90%;
        }
      }
    }
    .actionRow {
      padding: 20px;
      padding-top: 0;
      margin: 0 auto;
      .labels {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .labelItem {
          display: flex;
          align-items: center;
          height: 22px;
          margin-right: 16px;
          padding: 3px 8px 3px 4px;
          box-sizing: border-box;
          background: #3491FA1A;
          border-radius: 2px;
          color: #3491FA;
          .icon {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
      }
      .action {
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #4183D4;
          padding: 0 22px;
          margin-left: 20px;
          height: 34px;
          border: 1px solid #4183D4;
          border-radius: 20px;
          line-height: 34px;
          text-align: center;
          img {
            margin-right: 4px;
            width: 18px;
            height: 18px;
          }
          .rotate {
            transform: rotateY(180deg);
          }
        }
      }
    }
  }
  .sectionList {
    padding: 0 20px;
    .section {
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      margin-bottom: 16px;
      padding: 20px 32px;
      box-sizing: border-box;
      .title {
        margin-bottom: 16px;
        font-size: 18px;
        color: #387ED2;
        font-weight: bold;
      }
      .subSection {
        border: 1px solid #DCDFE6;
        .subsectionTitle {
          padding: 8px 16px;
          font-size: 16px;
          font-weight: bold;
          color: #387ED2;
          background: #3491FA1A;
        }
        .content {
          padding: 0 16px;
        }
        &+.subSection {
          margin-top: 16px;;
        }
      }
      .content {
        display: flex;
        justify-content: space-between;
        .main {
          flex: 1;
          margin-right: 16px;
          .item {
            .label {
              padding: 10px 0;
              border-bottom: 1px solid #DCDFE6;
              font-size: 14px;
              color: #387ED2;
              font-weight: bold;
            }
            .value {
              padding: 10px 0;
              font-size: 14px;
              color: #333333;
              line-height: 1.62;
              white-space: pre-line;
              .tag {
                display: inline-flex;
                align-items: center;
                height: 22px;
                padding: 3px 8px;
                margin-right: 14px;
                box-sizing: border-box;
                background: #3491FA1A;
                color: #3491FA;
              }
              .bullet {
                .bulletItem {
                  padding-left: 10px;
                  list-style: disc inside;
                }
              }
              .valueList {
                .valueItem {
                  .k {
                    font-size: 14px;
                    font-weight: bold;
                    color: #387ED2;
                  }
                }
              }
            }
          }
        }
        .infoList {
          width: 230px;
          .item {
            .label {
              padding: 10px 0;
              border-bottom: 1px solid #DCDFE6;
              font-size: 14px;
              color: #387ED2;
              font-weight: bold;
            }
            .value {
              padding: 10px 0;
              font-size: 14px;
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/trialDetail.vue